import Chip, { ChipProps } from '@mui/material/Chip';
import React from 'react';

interface Props extends ChipProps {
    hexColorFromServer?: string;
}

const hexToThemeColorMap: Record<string, 'primary' | 'warning' | 'error'> = {
    '#4D4D4D': 'primary',
    '#FFB400': 'warning',
    '#FF4C51': 'error',
};

const normalizeHex = (hex: string) => hex.trim().toUpperCase();

const CustomChip: React.FC<Props> = ({ hexColorFromServer = '', ...rest }) => {
    const normalizedHex = normalizeHex(hexColorFromServer);
    const chipColor = hexToThemeColorMap[normalizedHex] || 'default';

    return <Chip {...rest} color={chipColor} variant='tonal' />;
};

export default CustomChip;
